export default {
  REQUEST_FETCH_ARTICLES: 'REQUEST_FETCH_ARTICLES',
  FETCH_ARTICLES_ERROR: 'FETCH_ARTICLES_ERROR',
  FECTH_ARTICLES_SUCCESS: 'FECTH_ARTICLES_SUCCESS',
  RESET_ARTICLE: 'RESET_ARTICLE'
}
